import apiClient from 'lib/apiClient';

export const getModules = () =>
  apiClient.get('API/1_0/accessModules.php', {
    params: {
      order_by: 'access_module_name',
    },
  });

export const saveUserPermissions = (userId, permissions, groups, connections) =>
  apiClient.post('API/1_0/postUserPermissions.php', {
    user_id: userId,
    permissions,
    groups,
    connections,
  });

export const requestAccess = (permission) =>
  apiClient.post('API/1_0/postAccessRequest.php', {
    permission,
  });
